export default __webpack_public_path__ + "atomic/_patterns/02-molecules/press-release-teaser/_press-release-teaser.twig";